<template>
  <div class="modal fade create-new-user-modal" id="CreateCompanyModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Criar instalação</h1>
                  <button type="button" class="btn-close create-new-user-modal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <form ref="formRegisterCompany" @submit.prevent="submitRegisterCompany">
                <div class="row d-flex p-4 m-0 create-company-form-row">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25 col-12 col-sm-12 col-lg-6 col-xl-6 col-xxl-6 col-xxxl-6">
                    <label class="d-block text-black fw-semibold mb-10">Nome do cliente</label>
                    <input
                      ref="name"
                      type="text"
                      name="name"
                      class="form-control shadow-none rounded-0 text-black radius-7"
                      placeholder="Digite o nome do cliente"
                      @keyup="changeInformationInputs('name')"
                    />
                  </div>

                  <div class="form-group mb-15 mb-sm-20 mb-md-25 col-12 col-sm-12 col-lg-6 col-xl-6 col-xxl-6 col-xxxl-6">
                    <label class="d-block text-black fw-semibold mb-10">
                      Celular
                    </label>
                    <input
                      ref="cellphone"
                      type="text"
                      name="cellphone"
                      class="form-control shadow-none rounded-0 text-black radius-7"
                      placeholder="Digite o celular"
                      @keyup="changeInformationInputs('cellphone')"
                      @input="applyMaskPhone"
                      maxlength="15"
                    />
                  </div>

                  <div class="form-group mb-15 mb-sm-20 mb-md-25 col-12 col-sm-12 col-lg-6 col-xl-6 col-xxl-6 col-xxxl-6">
                    <label class="d-block text-black fw-semibold mb-10">
                      Telefone comercial
                    </label>
                    <input
                      ref="commercial_phone"
                      type="text"
                      name="commercial_phone"
                      class="form-control shadow-none rounded-0 text-black radius-7"
                      placeholder="Digite o seu telefone comercial"
                      @keyup="changeInformationInputs('commercial_phone')"
                      @input="applyMaskPhone"
                      maxlength="15"
                    />
                  </div>

                  <div class="form-group mb-15 mb-sm-20 mb-md-25 col-12 col-sm-12 col-lg-6 col-xl-6 col-xxl-6 col-xxxl-6">
                    <label class="d-block text-black fw-semibold mb-10">
                      Cpf ou cnpj
                    </label>
                    <input
                      ref="cpf_cnpj"
                      type="text"
                      name="cpf_cnpj"
                      class="form-control shadow-none rounded-0 text-black radius-7"
                      placeholder="Digite o seu cpf ou cnpj"
                      @keyup="changeInformationInputs('cpf_cnpj')"
                      @input="applyMaskCpfCnpj"
                      maxlength="18"
                    />
                  </div>

                  <div class="form-group col-12">
                    <button
                      class="default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 bg-success d-block w-100 pt-11 pb-11"
                      type="submit"
                      ref="button_submit_register"
                    >
                      Criar instalação
                    </button>
                  </div>

                  <div class="form-group col-12">
                    <div class="message-error-register" v-if="getErrorRegister != ''">
                      {{ getErrorRegister }}
                    </div>
                  </div>
                </div>
              </form>

          </div>
      </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: "CreateCompanyModal",
  data () {
    return {}
  },
  computed: {
    ...mapGetters([
      'getErrorRegister'
    ])
  },
  methods: {
    ...mapActions([
        "sendRegister"
    ]),
    changeInformationInputs(element){
      this.$refs[element].style.borderColor = "#dedee4";
    },
    applyMaskPhone(event) {
      const input = event.target;
      
      if(!input.value){
        return;
      }

      let value = input.value.replace(/\D/g, '');

      if (value.length > 10) {
        value = value.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      } else {
        value = value.replace(/^(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      }

      input.value = value;
    },
    applyMaskCpfCnpj(event) {
      const input = event.target;
      let value = input.value.replace(/\D/g, '');

      if (value.length > 11) {
        value = value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      } else {
        value = value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      }

      input.value = value;
    },
    hasLetters(str) {
      return /[a-zA-Z]/.test(str);
    },
    validateCaractersInputs(data){

      data.commercial_phone_01 = data.cellphone.replace(/[!@#$(.) /-]/g, "");
      data.commercial_phone_02 = data.commercial_phone.replace(/[!@#$(.) /-]/g, "");
      data.cpf_cnpj = data.cpf_cnpj.replace(/[!@#$(.) /-]/g, "");

      return data;
    },
    submitRegisterCompany(){
      const formData = new FormData(this.$refs['formRegisterCompany']);
      var data = {};
      for (let [key, val] of formData.entries()) {
        Object.assign(data, { [key]: val })
      }

      data = this.validateCaractersInputs(data);

      let error = false;
      if(data.name == ""){
        this.$refs["name"].style.borderColor = "red";
        error = true;
      }

      if(data.cellphone == "" || this.hasLetters(data.cellphone) || data.cellphone.length < 10){
        this.$refs["cellphone"].style.borderColor = "red";
        error = true;
      }
      
      if(data.commercial_phone != "" && (this.hasLetters(data.commercial_phone) || data.commercial_phone.length < 10)){
        this.$refs["commercial_phone"].style.borderColor = "red";
        error = true;
      }
      
      if(data.cpf_cnpj != "" && (this.hasLetters(data.cpf_cnpj) || (data.cpf_cnpj.length != 11 && data.cpf_cnpj.length != 14))){
        this.$refs["cpf_cnpj"].style.borderColor = "red";
        error = true;
      }

      if(error){
        return;
      }

      this.$refs.button_submit_register.innerHTML = "Carregando...";
      this.$refs.button_submit_register.disabled = true;

      this.sendRegister(data).then(() => {
        this.$refs.button_submit_register.innerHTML = "Criar instalação";
        this.$refs.button_submit_register.disabled = false;
      });
    },
  }
};
</script>

<style scoped>
.create-company-form-row {
  box-sizing: border-box;
}

.message-error-register {
  overflow-wrap: anywhere;
  word-break: break-word;
}
</style>
